import React from 'react';
import './Projects.css';
import HorizontalPanel from './HorizontalPanel';

const Projects = () => {
  return (
    <section id="projects" className="projects-section">
      <h1>Projects</h1>
      <HorizontalPanel />
    </section>
  );
};

export default Projects;
